import { useRef, useEffect } from 'react';
import '../useSSRLayoutEffect/index.js';
import useSSRLayoutEffect from '../useSSRLayoutEffect/useSSRLayoutEffect.js';

const useDidUpdateBase = (useEffectFunction, func, deps) => {
  const isFirstRenderRef = useRef(true);
  useEffectFunction(() => {
    if (isFirstRenderRef.current) {
      isFirstRenderRef.current = false;
      return undefined;
    }
    return func();
  }, deps);
};

/**
 * Wrapper around useEffect that runs on dependency updates only, not on initial render.
 * @param func - The effect function to run when dependencies have been updated.
 * @param deps - The list of dependencies to watch for changes.
 */
const useDidUpdate = (func, deps) => useDidUpdateBase(useEffect, func, deps);

/**
 * Wrapper around useSSRLayoutEffect that runs on dependency updates only, not on initial render.
 * @param func - The effect function to run when dependencies have been updated.
 * @param deps - The list of dependencies to watch for changes.
 */
const useEnhancedDidUpdate = (func, deps) => useDidUpdateBase(useSSRLayoutEffect, func, deps);

export { useDidUpdate, useEnhancedDidUpdate };
